import { Navbar } from "@/components/site/Navbar";
import { KineticHero } from "@/components/site/KineticHero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { About } from "@/components/site/About";
import { TheName } from "@/components/site/TheName";
import { Approach } from "@/components/site/Approach";
import { FocusAreas } from "@/components/site/FocusAreas";
import { WhoIWorkWith } from "@/components/site/WhoIWorkWith";
import { Services } from "@/components/site/Services";
import { Reflections } from "@/components/site/Reflections";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/scroll";

const IntroStrip = () => (
  <section className="py-20 md:py-28 bg-pawc-sand border-b border-pawc-teal/10">
    <div className="max-w-3xl mx-auto px-6">
      <Reveal>
        <p
          data-testid="intro-paragraph"
          className="font-serif text-2xl md:text-3xl leading-relaxed text-pawc-deep"
        >
          An HPCSA-registered Counselling Psychologist with a Master's degree cum
          laude from Wits University, working with young people and adults
          navigating trauma, emotional distress, and life transitions.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 rounded-2xl overflow-hidden border border-pawc-teal/10">
          <img
            src={IMAGES.stillLake}
            alt="A still, misty lake at first light"
            className="w-full h-[220px] md:h-[300px] object-cover"
            loading="lazy"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default function LandingPage() {
  return (
    <main>
      <Navbar />
      <KineticHero />
      <IntroStrip />
      <EditorialMarquee />
      <About />
      <TheName />
      <Approach />
      <FocusAreas />
      <WhoIWorkWith />
      <Services />
      <Reflections />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
